import type { Client } from "@opensea/graphql"
import type { Address } from "@opensea/utils"
import { prefetchProfilePageLayout } from "../../layout-query"

export function prefetchProfilePortfolioPage(address: Address, client: Client) {
  prefetchProfilePageLayout(address, client)
}
